/**
 * @generated SignedSource<<35ddcc7260baf80e58eefa8d4c00236c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectedCustomerRegisterValue_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly paymentMethodSelected: string | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodBoletoValue_charge" | "PaymentMethodCreditCardValue_charge" | "PaymentMethodPixValue_charge">;
  readonly " $fragmentType": "PaymentMethodSelectedCustomerRegisterValue_charge";
};
export type PaymentMethodSelectedCustomerRegisterValue_charge$key = {
  readonly " $data"?: PaymentMethodSelectedCustomerRegisterValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectedCustomerRegisterValue_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectedCustomerRegisterValue_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodSelected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPixValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodBoletoValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardValue_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "6125570b01790cf490abb33083cfdd7e";

export default node;
